import styled from 'styled-components';
import { RowDiv } from 'styles';
import { hexToRGB } from 'utils';

export const ContentBox = styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.primary900};
  border-bottom: 2px solid ${({ theme }) => theme.colors.primary900};
  padding: 48px 16px;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 24px 0;
  }
`;

export const GridDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;

  & > div:nth-child(4),
  & > div:nth-child(5),
  & > div:nth-child(6) {
    grid-column: span 3;
  }
  @media ${({ theme }) => theme.device.mobile} {
    display: flex;
    flex-direction: column;
  }
`;

export const StatBox = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 32px 24px;
  border-radius: 16px;
  background: ${({ theme }) => hexToRGB(theme.colors.primary900, 0.06)};
  text-align: center;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 24px 16px;
  }
`;

export const StatCount = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: center;
  font-size: 48px;
  font-weight: 800;
  line-height: 1.1;
  color: ${({ theme }) => theme.colors.primary900};

  & .unit {
    font-size: 24px;
    font-weight: 700;
    margin-left: 4px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    font-size: 34px;
    & .unit {
      font-size: 18px;
    }
  }
`;

export const RecentList = styled.ul`
  width: 100%;
  border-top: 2px solid ${({ theme }) => theme.colors.primary900};
`;

export const RecentItem = styled.li`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 8px;
  cursor: pointer;
  transition: background 150ms ease;
  border-bottom: 1px solid ${({ theme }) => hexToRGB(theme.colors.strong, 0.12)};

  &:hover {
    background: ${({ theme }) => hexToRGB(theme.colors.primary900, 0.04)};
  }

  & .title {
    flex: 1;
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 6px;
  }
  & .meta {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 16px;
  }

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    & .meta {
      gap: 12px;
    }
  }
`;

export const ButtonBox = styled(RowDiv)`
  margin-top: 24px;
  align-items: center;
  justify-content: center;
  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 0;
  }
`;
